// Config file for resources used in frontend component

export const RESOURCES = {
  // Club Application Resources
  CLUBS_MANUAL: '/files/clubs-manual',
  TRAINING_SLIDES: '/files/clubs-training-slides',
  DRAFT_CONSTITUTION_TEMPLATE: '/files/draft-constitution-template',

  // Event Form Resources
  UW_ROOM_TECH_LISTING: 'https://itms-pdupdate.uwaterloo.ca/information/index.php',
  WUSA_BOOKINGS: 'https://bookings.wusa.ca',
  WARRIOR_FACILITY_SCHEDULE: 'https://warrior.uwaterloo.ca/Facility/GetSchedule/',
  REGION_WATERLOO_SPECIAL_EVENT_FORM: 'https://forms.regionofwaterloo.ca/Public-Health/Special-Event-Form-for-Vendors',
  UW_POLICY_21: 'https://uwaterloo.ca/secretariat/policies-procedures-guidelines/policy-21',

  // Legal Resources
  WUSA_PRIVACY_POLICY: 'https://wusa.ca/privacy-policy/',
  WUSA_TERMS_AND_CONDITIONS: 'https://wusa.ca/terms-and-conditions/',

  // Common Resources
  CLUBS_ASSISTANT_EMAIL: 'clubs.assistant@wusa.ca',
};

export default RESOURCES;
